module.exports = __webpack_public_path__ + "static/media/task-notification-success.2cf4099b.svg";